import { render } from "./TextusForm.vue?vue&type=template&id=45e05dec&scoped=true"
import script from "./TextusForm.js?vue&type=script&lang=js&external"
export * from "./TextusForm.js?vue&type=script&lang=js&external"

import "./TextusForm.vue?vue&type=style&index=0&id=45e05dec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e05dec"]])

export default __exports__